import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Navbar from 'components/navbar';

export default function(
  ComposedComponent,
  { noAuth, noNav, adminOnly, hideProjectNav, anyAuth } = {}
) {
  class Authenticate extends Component {
    componentWillMount() {
      if (anyAuth) {
        return;
      }

      const { currentUser } = this.props;
      if (adminOnly) {
        if (!currentUser || currentUser.user_type_enum !== 1) {
          this.props.history.push('/');
        }
      }

      if (!localStorage.token && !noAuth) {
        this.props.history.push('/sign-in');
      } else if (localStorage.token && noAuth) {
        this.props.history.push('/');
      }
    }

    render() {
      return (
        <div style={{ height: '100%' }}>
          {localStorage.token &&
            !noAuth &&
            !noNav && <Navbar {...this.props} />}
          <ComposedComponent {...this.props} />
        </div>
      );
    }
  }

  return connect(state => {
    return {
      currentUser: state.users.map[state.sessionSettings.currentUserId]
    };
  })(withRouter(Authenticate));
}



// WEBPACK FOOTER //
// ./src/router/requireAuth.js